@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.enginemodule

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.coroutines.delay
import org.example.project.dashboard.DashboardTheme
import org.example.project.settings.UISettings
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ShopLayout(
    modules: List<ShopModuleMeta>,
    moduleStates: Map<String, ModuleState>,
    progressMap: Map<String, Int>,
    onInstall: (ShopModuleMeta) -> Unit,
    onActivate: (ShopModuleMeta) -> Unit,
    onDeactivate: (ShopModuleMeta) -> Unit,
    onUpdate: (ShopModuleMeta) -> Unit,
    onOpenDetails: (ShopModuleMeta) -> Unit,
    selectedDetailModule: ShopModuleMeta? = null,
    selectedDetailState: ModuleState? = null,
    onCloseDetails: () -> Unit = {},
    showHeaderTabs: Boolean = true,
    showFeaturedHero: Boolean = true,
    showOwnershipStagePanel: Boolean = false,
    showPurchaseOnly: Boolean = false,
    readOnly: Boolean = false,
    emptyStateText: String = "Keine aktiven Module vorhanden.",
    sectionTitle: String = "Module die dir gefallen könnten",
    featuredActiveUserCount: Int = 0,
    sideNavigationContent: (@Composable () -> Unit)? = null,
    heroNavigationContent: (@Composable () -> Unit)? = null,
    featuredSource: List<ShopModuleMeta> = modules
) {
    val showDetailView = selectedDetailModule != null && selectedDetailState != null
    val featuredHeroAutoAdvanceMs = 5000L
    val featuredModules = featuredSource.sortedByDescending { it.moduleId }.take(5).ifEmpty { featuredSource.take(1) }
    var featuredIndex by remember(featuredModules.map { it.key }) { mutableStateOf(0) }
    var autoPlayFeaturedHero by remember(featuredModules.map { it.key }) { mutableStateOf(true) }
    if (featuredModules.isNotEmpty() && featuredIndex > featuredModules.lastIndex) featuredIndex = 0
    val featuredModule = featuredModules.getOrNull(featuredIndex)

    LaunchedEffect(showFeaturedHero, featuredModules.map { it.key }, autoPlayFeaturedHero) {
        if (!showFeaturedHero || featuredModules.size <= 1 || !autoPlayFeaturedHero) return@LaunchedEffect
        while (autoPlayFeaturedHero) {
            delay(featuredHeroAutoAdvanceMs)
            if (!autoPlayFeaturedHero) break
            featuredIndex = (featuredIndex + 1) % featuredModules.size
        }
    }

    Div({
        style {
            padding(0.px, 28.px, 40.px, 28.px)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(12.px)
            width(100.percent)
            maxWidth(100.percent)
            property("box-sizing", "border-box")
        }
    }) {
        if (showHeaderTabs) {
            Div({
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.FlexEnd)
                    gap(24.px)
                    flexWrap(FlexWrap.Wrap)
                    paddingBottom(12.px)
                }
            }) {
                ShopHeaderTab(
                    label = "Modul Shop",
                    active = !showDetailView,
                    onClick = { if (showDetailView) onCloseDetails() }
                )
                if (showDetailView) {
                    ShopHeaderTab(label = "Details", active = true)
                }
                ShopHeaderTab(label = "Meine Module", active = false)
            }
        }

        val currentFeaturedModule = featuredModule
        if (!showDetailView && sideNavigationContent != null) {
            Div({
                style {
                    width(100.percent)
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.Center)
                    padding(0.px, 28.px, 0.px, 28.px)
                    property("box-sizing", "border-box")
                }
            }) {
                sideNavigationContent()
            }
        }

        if (!showDetailView && heroNavigationContent != null && (!showFeaturedHero || currentFeaturedModule == null)) {
            heroNavigationContent()
        }

        if (!showDetailView && showFeaturedHero && currentFeaturedModule != null) {

            Div({
                style {
                    width(100.percent)
                    display(DisplayStyle.Grid)
                    property("grid-template-columns", "minmax(140px, 1fr) minmax(0, 1120px) minmax(140px, 1fr)")
                    padding(0.px, 28.px)
                    alignItems(AlignItems.Center)
                    property("box-sizing", "border-box")
                }
            }) {
                if (heroNavigationContent != null) {
                    Div({
                        style {
                            property("grid-column", "1")
                            display(DisplayStyle.Flex)
                            justifyContent(JustifyContent.Center)
                            padding(0.px, 16.px)
                            boxSizing("border-box")
                        }
                    }) { heroNavigationContent() }
                }
                val featuredModuleType = currentFeaturedModule.modulKategorie.trim()
                val featuredModuleUsers = if (currentFeaturedModule.purchased || currentFeaturedModule.installed) featuredActiveUserCount.toString() else "0"
                val featuredMetaType = currentFeaturedModule.modulKategorie.trim()
                    .ifBlank { featuredModuleType }
                Div({
                        style {
                            property("grid-column", "2")
                            width(1120.px)
                            minWidth(0.px)
                            maxWidth(100.percent)
                            minHeight(318.px)
                            borderRadius(26.px)
                            property("border", "1px solid rgba(255,255,255,0.12)")
                            property("background", DashboardTheme.PREMIUM_SURFACE_BG)
                            property("box-shadow", "0 24px 54px rgba(0,0,0,0.30)")
                            padding(24.px)
                            boxSizing("border-box")
                        }
                    }) {
                    Div({
                        style {
                            display(DisplayStyle.Grid)
                            property("grid-template-columns", "minmax(320px, 40%) minmax(0, 1fr)")
                            gap(24.px)
                            minHeight(270.px)
                        }
                    }) {
                        Div({
                            style {
                                minHeight(270.px)
                                borderRadius(22.px)
                                property("border", "1px solid rgba(255,255,255,0.12)")
                                property(
                                    "background",
                                    if (currentFeaturedModule.iconPath.isNotBlank()) {
                                        "linear-gradient(115deg, rgba(91,155,255,0.10) 0%, rgba(15,19,26,0.42) 68%), url('${currentFeaturedModule.iconPath}') center/cover no-repeat"
                                    } else {
                                        UISettings.BLUE_SURFACE_GRADIENT
                                    }
                                )
                                overflow("hidden")
                                position(Position.Relative)
                            }
                        }) {}

                        Div({
                            style {
                                display(DisplayStyle.Flex)
                                flexDirection(FlexDirection.Column)
                                justifyContent(JustifyContent.SpaceBetween)
                                minWidth(0.px)
                                padding(10.px, 4.px, 2.px, 0.px)
                                boxSizing("border-box")
                            }
                        }) {
                            Div({
                                style {
                                    display(DisplayStyle.Flex)
                                    flexDirection(FlexDirection.Column)
                                    gap(14.px)
                                    minWidth(0.px)
                                }
                            }) {
                                H2({
                                    style {
                                        margin(0.px)
                                        color(Color("#f5f7fb"))
                                        fontSize(34.px)
                                        fontWeight("700")
                                        lineHeight("1.08")
                                        property("word-break", "break-word")
                                    }
                                }) {
                                    Text(currentFeaturedModule.title)
                                }

                                P({
                                    style {
                                        margin(0.px)
                                        color(Color("rgba(228,234,245,0.78)"))
                                        fontSize(15.px)
                                        lineHeight("1.6")
                                        maxWidth(520.px)
                                        property("display", "-webkit-box")
                                        property("-webkit-line-clamp", "6")
                                        property("-webkit-box-orient", "vertical")
                                        property("overflow", "hidden")
                                        property("text-overflow", "ellipsis")
                                    }
                                }) {
                                    Text(currentFeaturedModule.description)
                                }

                                Div({
                                    style {
                                        display(DisplayStyle.Flex)
                                        alignItems(AlignItems.Center)
                                        gap(10.px)
                                        flexWrap(FlexWrap.Wrap)
                                        color(Color("rgba(188,199,216,0.88)"))
                                        fontSize(13.px)
                                        fontWeight("500")
                                        letterSpacing(0.2.px)
                                    }
                                }) {
                                    Span { Text("Version ${currentFeaturedModule.version}") }
                                    Span({ style { color(Color("rgba(126,138,158,0.80)")) } }) { Text("|") }
                                    Span { Text(featuredMetaType) }
                                    Span({ style { color(Color("rgba(126,138,158,0.80)")) } }) { Text("|") }
                                    Span { Text("Screens: ${currentFeaturedModule.enabledScreens.size}") }
                                    Span({ style { color(Color("rgba(126,138,158,0.80)")) } }) { Text("|") }
                                    Span { Text("$featuredModuleUsers Nutzer") }
                                    Span({ style { color(Color("rgba(126,138,158,0.80)")) } }) { Text("|") }
                                    Span({
                                        style {
                                            color(UISettings.ACCENT)
                                            fontSize(13.px)
                                            fontWeight("700")
                                            cursor("pointer")
                                        }
                                        onClick { onOpenDetails(currentFeaturedModule) }
                                    }) { Text("Mehr Erfahren") }
                                }
                            }

                            Div({
                                style {
                                    display(DisplayStyle.Flex)
                                    justifyContent(JustifyContent.FlexEnd)
                                    alignItems(AlignItems.Center)
                                    gap(14.px)
                                    paddingTop(18.px)
                                }
                            }) {
                                Img(src = "images/left.svg", attrs = {
                                    style {
                                        width(16.px)
                                        height(16.px)
                                        cursor(if (featuredIndex == 0) "default" else "pointer")
                                        opacity(if (featuredIndex == 0) 0.32 else 0.88)
                                        property("filter", "brightness(0) invert(0.92)")
                                    }
                                    onClick {
                                        if (featuredIndex > 0) featuredIndex -= 1
                                    }
                                })

                                Span({
                                    style {
                                        color(Color("#f4f6fb"))
                                        fontSize(14.px)
                                        fontWeight("600")
                                        minWidth(54.px)
                                        textAlign("center")
                                    }
                                }) { Text("${featuredIndex + 1}/${featuredModules.size}") }

                                Img(src = "images/right.svg", attrs = {
                                    style {
                                        width(16.px)
                                        height(16.px)
                                        cursor(if (featuredIndex >= featuredModules.lastIndex) "default" else "pointer")
                                        opacity(if (featuredIndex >= featuredModules.lastIndex) 0.32 else 0.88)
                                        property("filter", "brightness(0) invert(0.92)")
                                    }
                                    onClick {
                                        if (featuredIndex < featuredModules.lastIndex) featuredIndex += 1
                                    }
                                })

                                Img(src = if (autoPlayFeaturedHero) "images/pause.svg" else "images/play_arrow.svg", attrs = {
                                    style {
                                        width(18.px)
                                        height(18.px)
                                        cursor(if (featuredModules.size > 1) "pointer" else "default")
                                        opacity(if (featuredModules.size > 1) 0.92 else 0.38)
                                        property("filter", "brightness(0) invert(0.92)")
                                    }
                                    onClick {
                                        if (featuredModules.size > 1) autoPlayFeaturedHero = !autoPlayFeaturedHero
                                    }
                                })
                            }
                        }
                    }
                }
            }
        }

        if (!showDetailView) {
            Div({
                style {
                    width(100.percent)
                    height(1.px)
                    backgroundColor(Color("rgba(255,255,255,0.08)"))
                    marginTop(2.px)
                    marginBottom(2.px)
                }
            })

            H2({
                style {
                    width(100.percent)
                    maxWidth(1120.px)
                    property("margin", "10px auto 2px")
                    color(DashboardTheme.TEXT_LIGHT)
                    fontSize(24.px)
                    fontWeight("700")
                    lineHeight("1.2")
                    boxSizing("border-box")
                }
            }) { Text(sectionTitle) }
        }

        AnimatedShopSection(contentKey = selectedDetailModule?.key ?: "grid") {
            if (showDetailView) {
                ShopModuleDetails(
                    module = selectedDetailModule,
                    state = selectedDetailState,
                    onClose = onCloseDetails,
                    onInstall = { onInstall(selectedDetailModule) },
                    onActivate = { onActivate(selectedDetailModule) },
                    onDeactivate = { onDeactivate(selectedDetailModule) },
                    onUpdate = { onUpdate(selectedDetailModule) },
                    readOnly = readOnly
                )
            } else if (modules.isEmpty()) {
                P({ style { color(Color("#FFA726")); margin(0.px) } }) {
                    Text(emptyStateText)
                }
            } else {
                Div({
                    style {
                        display(DisplayStyle.Grid)
                        property("grid-template-columns", "repeat(auto-fit, minmax(360px, 360px))")
                        justifyContent(JustifyContent.Center)
                        gap(18.px)
                    }
                }) {
                    modules.forEach { module ->
                        val state = moduleStates[module.key] ?: ModuleStateVal.AVAILABLE
                        EditorModuleCard(
                            module = module,
                            state = state,
                            selected = false,
                            onSelect = { onOpenDetails(module) },
                            showInstalledMeta = showOwnershipStagePanel
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun AnimatedShopSection(
    contentKey: String,
    content: @Composable () -> Unit
) {
    var visible by remember(contentKey) { mutableStateOf(false) }

    LaunchedEffect(contentKey) {
        delay(20)
        visible = true
    }

    Div({
        style {
            width(100.percent)
            opacity(if (visible) 1 else 0)
            property("transform", if (visible) "translateY(0px)" else "translateY(8px)")
            property("transition", "opacity 220ms ease, transform 220ms ease")
        }
    }) {
        content()
    }
}

@Composable
private fun ShopHeaderTab(label: String, active: Boolean, onClick: (() -> Unit)? = null) {
    Span({
        style {
            color(if (active) UISettings.ACCENT else Color("#cfd6e2"))
            fontSize(15.px)
            fontWeight(if (active) "700" else "500")
            padding(0.px, 2.px, 10.px, 2.px)
            property("border-bottom", if (active) "2px solid ${UISettings.ACCENT}" else "2px solid transparent")
            property("white-space", "nowrap")
            cursor(if (onClick != null) "pointer" else "default")
        }
        onClick { onClick?.invoke() }
    }) { Text(label) }
}





